import * as z from 'zod/v4';

import { CHAIN_KEYS } from '@infinex/chain-config';
import { CUSTODIES } from '@infinex/types';

export const MAXIMUM_GAS_ACCOUNT_BALANCE = 100; // $100
export const MINIMUM_GAS_ACCOUNT_TOPUP = 0.25; // $0.25
export const GAS_ACCOUNT_BALANCE_TOLERANCE = 2.5;

const topUpTypes = z.enum(['jit_top_up', 'prepaid_top_up']);
const gasQuoteBase = z.object({
  chain: z.enum(CHAIN_KEYS).optional(),
  assetAddress: z.string().optional(),
  gasAmount: z
    .number()
    .min(MINIMUM_GAS_ACCOUNT_TOPUP)
    .max(MAXIMUM_GAS_ACCOUNT_BALANCE),
  userWalletId: z.string().optional(),
  custody: z.enum(CUSTODIES).default('wallet'),
  topUpType: topUpTypes,

  isMaxTopup: z.boolean().optional(),
});

export const getGasQuoteInput = gasQuoteBase;

export type GetGasQuoteInput = z.input<typeof getGasQuoteInput>;

export const gasDepositQuote = z.object({
  status: z.literal('succeeded'),
  quoteId: z.string(),
  // The gas amount being quoted on
  gasAmount: z.number(),
  // Where the funds will be taken from (wallet ID or undefined for vault)
  userWalletId: z.string().optional(),
  // The custody type of the source
  custody: z.enum(CUSTODIES),
  // chainRuntimeAddressAddress (wallet) or vault address
  chainRuntimeAddress: z.string(),
  // The asset to be used for the deposit
  assetChain: z.enum(CHAIN_KEYS),
  assetAddress: z.string(),
  assetAmount: z.string(),
  assetDecimals: z.number(),
  usdRate: z.number(),

  topUpType: topUpTypes,
});

export const GAS_DEPOSIT_QUOTE_REJECTION_REASONS = [
  'no_supported_assets',
  'insufficient_balance',
  'exceeds_maximum_balance',
  'wallet_id_required',
  'wallet_not_found',
  'no_vaults_configured',
] as const;
export const gasDepositQuoteRejection = z.object({
  status: z.literal('rejected'),
  rejectionReason: z.enum(GAS_DEPOSIT_QUOTE_REJECTION_REASONS),
});

export const gasDepositQuoteOutput = z.discriminatedUnion('status', [
  gasDepositQuote,
  gasDepositQuoteRejection,
]);

export type GasDepositQuoteOutput = z.input<typeof gasDepositQuoteOutput>;
